import React from 'react'

const Footer = () => (
  <div className="footer">
    © Copyright {(new Date()).getFullYear()}. With 💙 &nbsp;from <a href="https://hera.marketing" target="blank">Hera Marketing</a>. Build your personal brand. @hera.marketing | @centamadi
  </div>
)

export default Footer